import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import { currentMaxZoomState } from '../../../app/redux/retrievers/retrievers';

import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

interface ClusterGeneratorProps {
    coordinates: any;
    filterFunction: Function;
    mapFunction: Function;
    clusterOptions: any;
}
const ClusterGenerator: React.FC<ClusterGeneratorProps> = ({ coordinates, filterFunction, mapFunction, clusterOptions }) => {
    const currentMaxZoom = useSelector(currentMaxZoomState);
    // console.log('current max zoom: ', currentMaxZoom);
    const map = useMap();
    map.setMaxZoom(currentMaxZoom);

    //@ts-ignore
    const ClusterGroup = useMemo(
        () =>
            //@ts-ignore
            L.markerClusterGroup(clusterOptions),
        [currentMaxZoom],
    );

    const clusterLayers = useMemo(
        () =>
            coordinates && coordinates.filter((coord: any) => filterFunction(coord)).map((coord: any) => mapFunction(coord)),
        [coordinates, currentMaxZoom],
    );

    useEffect(() => {
        clusterLayers && clusterLayers.forEach((clusterLayer: any) => ClusterGroup.addLayer(clusterLayer));
        map.addLayer(ClusterGroup);

        return () => {
            clusterLayers.forEach((clusterLayer: any) => ClusterGroup.removeLayer(clusterLayer));
            map.removeLayer(ClusterGroup);
        };
    }, [ClusterGroup, clusterLayers, map]);

    return null;
};

export default ClusterGenerator;
